import React from "react";
import { Input } from "reactstrap";
import Helpers from "../../../../Utils/Helpers";


let ExportFormType = props => {
    const { onExportTypeChanged } = props;
    const id = Helpers.uniqId();

    return <div>
        <div className="bold">Fr&eacute;quence d'export *</div>
        <br />

        <Input 
            type="radio" 
            name={`extractFreq-${id}`}
            className="marg-l-0 marg-r-10 relative" 
            value="unique"
            defaultChecked
            onChange={e => { 
                onExportTypeChanged(e.target.value)
            }} 
        />
        Export unique

        <br />
        
        <Input 
            type="radio" 
            name={`extractFreq-${id}`}
            className="marg-l-0 marg-r-10 relative" 
            value="recurrent"
            onChange={e => { 
                onExportTypeChanged(e.target.value)
            }} 
        />
        Export r&eacute;current
    </div>;
};

export default ExportFormType;


// WEBPACK FOOTER //
// ./src/components/Operations/Export/Forms/Type.js